import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  EN_NAME_OPTIONS,
  LANG,
  LOCALIZE_NAME_OPTIONS,
} from "~/constans/commom";
import { Filter } from "~/features/filter";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";

import { indicatorsFilterFields } from "./fields";

const IndicatorsFilter = () => {
  const { t, i18n } = useTranslation();
  const setData = useSetLocationData();
  const { searchField } = useGetLocationData();

  const fields = useMemo(
    () => indicatorsFilterFields(t, localStorage.getItem("language")),
    [t, i18n.language],
  );

  const isEn = localStorage.getItem("language") === LANG.en;

  // При смене языка локализованное поле поиска (name/nameEn и т.п.)
  // сбрасывается, чтобы поиск не уходил в поле другого языка —
  // поведение сохранено со старого ~/components/Filter.
  useEffect(() => {
    if ([...LOCALIZE_NAME_OPTIONS, ...EN_NAME_OPTIONS].includes(searchField)) {
      setData("searchField", "");
    }
    // Эффект должен срабатывать только на монтировании и при смене языка,
    // иначе выбор локализованного поля тут же сбрасывался бы.
  }, [isEn]);

  return <Filter.Root fields={fields} alwaysShow columns={2} />;
};

export default IndicatorsFilter;
